import { createAsyncThunk } from '@reduxjs/toolkit'
import { UseFormReturn } from 'react-hook-form/dist/types/form'
import contactRequest from 'src/api/requests/contact'
import { ContactInterface } from 'src/interfaces/Contact'
import uiActions from 'src/store/ui/notification'

export interface PostContact {
  params: ContactInterface
  form?: UseFormReturn<ContactInterface, any>
}

export const submitContact = createAsyncThunk<any, PostContact>(
  'contact/submit',
  async ({ params, form }, { dispatch, rejectWithValue }) => {
    try {
      const res = await contactRequest.sendContact(params)

      dispatch(
        uiActions.onNotification({
          type: 'success',
          message: 'お問い合わせを送信しました。ありがとうございます。',
        }),
      )

      form?.reset?.()

      return res.data
    } catch (err: any) {
      dispatch(
        uiActions.onNotification({
          type: 'error',
          message:
            err?.response?.data?.message ||
            '送信に失敗しました。もう一度お試しください。',
        }),
      )
      return rejectWithValue(err)
    }
  },
)
